import { render, staticRenderFns } from "./InputBankName.vue?vue&type=template&id=28548860&scoped=true&"
import script from "./InputBankName.vue?vue&type=script&lang=ts&"
export * from "./InputBankName.vue?vue&type=script&lang=ts&"
import style0 from "./InputBankName.vue?vue&type=style&index=0&id=28548860&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28548860",
  null
  
)

export default component.exports